import axios from "axios"
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL
let UserType = JSON.parse(localStorage.getItem("WWINGS_USER_TYPE"))

export const addCustomerAPI = async customerData => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/createCustomer`,
      customerData,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error adding Customer:", error)
    throw error
  }
}

//  to get customer

export const getCustomerAPI = async payload => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

 // return await axios.post(`${apiBaseUrl}/get-customers`, payload, { headers })

  if (UserType && UserType === "Admin") {
    return await axios.post(`${apiBaseUrl}/get-customers`, payload, {
      payload,
      headers,
    })
  } else {
    return await axios.get(`${apiBaseUrl}/myCustomers`, {
      payload,
      headers,
    })
  }
}
// view-customer

export const SingleCustomerAPI = async customerData => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  const data = {
    id: customerData,
  }
  try {
    const response = await axios.post(`${apiBaseUrl}/view-customer`, data, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error adding Customer:", error)
    throw error
  }
}

// to delete customer

export const deleteCustomerAPI = async payload => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  return await axios.post(`${apiBaseUrl}/delete-customer`, payload.payload, {
    headers,
  })
}

export const EditCustomerAPI = async CustData => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }
  try {
    const response = await axios.post(
      `${apiBaseUrl}/updateCustomer`,
      CustData,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error adding customer:", error)
    throw error
  }
}

// Customer Type API :

export const getCustomerTypeAPI = async payload => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  return await axios.get(`${apiBaseUrl}/customer-types`, {
    headers,
  })
}

export const addCustomerFollowupAPI = async customerData => {
  try {
    let apiToken = await JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/create-customerlog`,
      customerData,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error adding Customer Followup:", error)
    throw error
  }
}

export const getCustomerFollowupAPI = async customerData => {
  try {
    let apiToken = await JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/view-customer-logs`,
      customerData,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error Getting Customer Followup:", error)
    throw error
  }
}

export const getCustomerProfileAPI = async customerData => {
  try {
    const data = {
      customer_id: customerData,
    }
    let apiToken = await JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/get-customer-profile`,
      data,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error Getting Customer Followup:", error)
    throw error
  }
}

export const updateCustomerProfileAPI = async customerData => {
  try {
    let apiToken = await JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "multipart/form-data",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/update-customer-profile`,
      customerData,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error Getting Customer Followup:", error)
    throw error
  }
}

//

export const getCustomerNameAPI = async payload => {
  try {
    const data = {
      customer_id: payload,
    }
    let apiToken = await JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(`${apiBaseUrl}/customer/name`, data, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error Getting Customer Followup:", error)
  }
}


export const uploadFileAPI = async payload => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))
  const headers = {
    // Don't set Content-Type here for multipart/form-data
    Authorization: apiToken, // or `Bearer ${apiToken}` if that's what your backend expects
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  // axios will set the correct Content-Type + boundary for FormData
  const response = await axios.post(`${apiBaseUrl}/uploadCustomerFiles`, payload, {
    headers,
  })
  return response
}


export const getUploadFileAPI = async payload => {
  let apiToken = await JSON.parse(localStorage.getItem("authUser"))
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  const response = await axios.post(`${apiBaseUrl}/viewCustomerFile`, payload, {
    headers,
  })
  return response
}


export const createUploadFileLinkAPI = async payload => {
  let apiToken = await JSON.parse(localStorage.getItem("authUser"))
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  const response = await axios.post(`${apiBaseUrl}/createLink`, payload, {
    headers,
  })
  return response
}


export const uploadFileLinkAPI = async payload => {
  let apiToken = await JSON.parse(localStorage.getItem("authUser"))
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "multipart/form-data",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  const response = await axios.post(`${apiBaseUrl}/uploadCustomerFilesFromLink`, payload, {
    headers,
  })
  return response
}


export const custViewFilesAPI = async payload => {
  let apiToken = await JSON.parse(localStorage.getItem("authUser"))
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  const response = await axios.post(`${apiBaseUrl}/view-filesFromLink`, payload, {
    headers,
  })
  return response
}

export const deleteFileAPI = async payload => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  return await axios.post(`${apiBaseUrl}/delete-file`, payload, {
    headers,
  })
}


export const getBlockedCustAPI = async payload => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  return await axios.get(`${apiBaseUrl}/get-blocked-customer`, {
    headers,
  })
}


export const editCustFilesAPI = async payload => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  return await axios.post(`${apiBaseUrl}/edit-fileName`,payload, {
    headers,
  })
}